export default "__VITE_ASSET__BvInyBDe__"